export const blueScores: number[] = [1, 2, 4, 7, 11, 16, 22, 29, 37, 46, 56]
export const greenScores: number[] = [1, 3, 6, 10, 15, 21, 28, 36, 45, 55, 66]
